import { render, staticRenderFns } from "./linkedauthors.vue?vue&type=template&id=0f1cf4b7"
import script from "./linkedauthors.vue?vue&type=script&lang=ts"
export * from "./linkedauthors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports